import { render, staticRenderFns } from "./DetmirElementConfigurableScaleMaxTableColumn.vue?vue&type=template&id=21b3d6b1"
import script from "./DetmirElementConfigurableScaleMaxTableColumn.vue?vue&type=script&lang=js"
export * from "./DetmirElementConfigurableScaleMaxTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports